// Maps sidebar route → module_key in modules_catalogue.
// Items NOT in this map are considered always-visible (core platform pages).
export const ROUTE_TO_MODULE = {
  "/hydrant": "hydrant_system",
  "/sprinkler": "sprinkler_system",
  "/tank": "fire_water_tank",
  "/detection": "detection_system",
  "/ventilation": "ventilation_system",
  "/lifts-module": "lifts_module",
  "/pumps": "pumps_registry",
  "/registry/pressure-sensors": "pressure_sensors",
  "/registry/tanks": "tanks_registry",
  "/registry/valves": "valves_registry",
  "/registry/lifts": "lifts_registry",
  "/registry/fans": "fans_ahu_registry",
  "/registry/fire-alarm-devices": "fire_alarm_devices",
  "/panels": "panels_management",
  "/devices": "device_management",
  "/floors": "floor_plans",
  "/gateways": "hardware_gateways",
  "/alerts": "alert_management",
  "/reports": "reports_logs",
  "/audit": "audit_log",
  "/billing": "billing_plan",
  "/subscription": "subscription_revenue",
  "/users": "user_management",
  "/roles": "roles_permissions",
  "/certificate": "acms_certificate",
  "/controller": "controller_settings",
  "/settings": "system_settings",
};

// Role → default visible admin items. super_admin sees everything.
export const ROLE_ADMIN_ACCESS = {
  super_admin: "ALL",
  platform_support: "ALL",
  customer_admin: "ALL",
  admin: "ALL",
  site_manager: ["billing_plan", "reports_logs", "audit_log"],
  building_manager: [],
  fire_safety_officer: [],
  viewer: [],
};
